<div *ngIf="show" class="sis-toast" [class]="'sis-toast sis-toast--' + tone" role="status" aria-live="polite">
  <span class="sis-toast-message">{{ message }}</span>
  <button class="sis-toast-close" type="button" aria-label="Cerrar notificación" (click)="close.emit()">×</button>
</div>
